var map = {
	"./Arcobaleno/Arcobaleno_1.jpg": 657,
	"./Arcobaleno/Erminio_5.jpg": 1330,
	"./Arcobaleno/Iolanda_10.jpg": 485,
	"./Arcobaleno/Maurizio_8.jpg": 746,
	"./Mamma/0002_5.jpg": 5322,
	"./Mamma/F1000013.jpg": 9827,
	"./Mamma/F1000018.jpg": 1564,
	"./Photos-accueil/Erminio.jpg": 8912,
	"./Photos-accueil/Iolanda_4.jpg": 6654,
	"./Photos-accueil/Paysage.jpg": 8753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2729;